import { LogboekEntryDto } from "@/shared/types";
import { compareDesc } from "date-fns";
import { LogboekItemBron } from "./constants";

export type LogboekItem = {
    id: number;
    datumTijd: Date;
    titel: string;
    bron: LogboekItemBron;
    persoon?: string;
    bericht?: string;
};

export const LogboekItem = {
    fromDto: (item: LogboekEntryDto): LogboekItem => {
        return {
            id: item.id,
            datumTijd: new Date(item.datumTijd),
            titel: item.titel,
            bron: LogboekItem.bronFromDto(item.bron),
            persoon: item.bronPersoon,
            bericht: item.toelichting,
        };
    },
    bronFromDto: (bron: LogboekEntryDto["bron"]): LogboekItemBron => {
        switch (bron) {
            case "Spoorweb":
                return LogboekItemBron.SPOORWEB;
            case "Regievoerder":
                return LogboekItemBron.REGIEVOERDER;
            case "Klantenservice":
                return LogboekItemBron.KLANTENSERVICE;
            case "RegiecentrumBus":
                return LogboekItemBron.RCB;
            default:
                return LogboekItemBron.REGIEVOERDER;
        }
    },
    sort: (logboekItemA: LogboekItem, logboekItemB: LogboekItem) => {
        return compareDesc(logboekItemA.datumTijd, logboekItemB.datumTijd);
    },
};
